import "../../sap/ui/core/date/Islamic.js";
